<template>
    <footer class="J-page-footer">
        <div class="log">
            <img src="../assets/logo.png" alt=""></img>
        </div>
        <div class="footer-center">
            <div class="footer-btn-list" :class="currentLang === 'CN' ? '':'en-m-list'">
                <a href="/about.html" class="footer-btn">{{ currentLang === 'CN' ? '关于蜂巢' : 'About' }}</a>
                <a href="/engine.html" class="footer-btn">{{ currentLang === 'CN' ? '动力系统' : 'Engine System' }}</a>
                <a href="/transmission.html" class="footer-btn">{{ currentLang === 'CN' ? '传动系统' : 'Transmission System' }}</a>
                <a href="/electronics.html" class="footer-btn">{{ currentLang === 'CN' ? '电子系统' : 'Electronics System' }}</a>
                <a href="/manufacture.html" class="footer-btn">{{ currentLang === 'CN' ? '智能制造' : 'Intelligent Manufacturing' }}</a>
                <a href="/contact-us.html" class="footer-btn">{{ currentLang === 'CN' ? '商务合作' : 'Contact Us' }}</a>
            </div>
            <div class="footer-icon">
                <div class="footer-title">
                    {{ currentLang === 'CN' ? '关注我们' : 'Stay Connected' }}
                </div>
                <div class="footer-desc">
                    {{ currentLang === 'CN' ? '通过社交媒体与我们联系' : 'Contact Us via Social Media' }}
                </div>
                <div class="footer-icon-list">
                    <a target="_blank" href="https://www.douyin.com/user/MS4wLjABAAAAS5emzB-jw8YlR8tixveOuMYym-CaP71WB1Cl98VseDA" v-if="currentLang === 'CN'" class="footer-icon-item">
                        <img class="footer-icon-img" src="/assets/common/dy.png" alt=""></img>
                    </a>
                    <div class="footer-icon-item" @click="clickIcon1">
                        <img  class="footer-icon-img" :src="currentLang === 'CN' ? '/assets/common/wx.png' : '/assets/common/Linkedin.png'" alt=""></img>
                        <div class="footer-icon-box" v-if="isPc || icon1" >
                            <img :src="currentLang === 'CN' ? '/assets/common/wx-code.png' : '/assets/common/Linkedin-code.png'" alt=""></img>
                            <img class="footer-icon-colse-btn" src="/assets/about/close.png" v-if="!isPc" alt=""></img>
                        </div>
                    </div>
                    <div class="footer-icon-item" v-if="currentLang === 'CN'"  @click="clickIcon2">
                        <img class="footer-icon-img"  src="/assets/common/wb.png" alt=""></img>

                        <div class="footer-icon-box" v-if="isPc || icon2">
                            <img src="/assets/common/wb-code.png" alt=""></img>
                            <img class="footer-icon-colse-btn" src="/assets/about/close.png" v-if="!isPc" alt=""></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="footer-bottom-privacy-list" v-if="currentLang === 'CN'">
                <a href="/privacy.html">{{ currentLang === 'CN' ? '隐私政策' : 'Privacy Policy' }}</a>

            </div>
            <div class="footer-filing">
                {{ currentLang === 'CN' ? 'Copyright 2026 蜂巢汽车科技集团有限公司' : 'Copyright 2026 FINEST Automotive Technology Group Co., Ltd.' }}
                <a href="https://beian.miit.gov.cn/#/Integrated/index">冀ICP备19007688号-5</a>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const currentLang = computed(() => store.getters.currentLang);

const isPc = ref ( window.innerWidth > 768 )

const icon1 = ref(false);
const icon2 = ref(false);

const clickIcon1 = () => {
    icon1.value = !icon1.value;
}
const clickIcon2 = () => {
    icon2.value = !icon2.value;
}




</script>
<script>
if (import.meta.webpackHot) {
    import.meta.webpackHot.accept('./Footer.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss">
.J-page-footer {
    background: #F7F9FB;
    padding: 0.47rem 0;

    .log {
        width: auto;
        height: 0.38rem;
        margin-bottom: 0.19rem;
        padding: 0 1.56rem;

        img {
            width: auto;
            height: 100%;
            object-fit: cover;
        }
    }

    .footer-center {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 0 1.56rem;
        padding-bottom: 0.28rem;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.24);

        .footer-btn-list {
            display: flex;
            align-items: center;
            gap: 0.57rem;
            font-size: 0.15rem;
            font-weight: 400;
        }

        .footer-icon {
            color: #000;

            .footer-title {
                font-size: 0.21rem;
                font-weight: 400;
            }

            .footer-desc {
                font-size: 0.14rem;
                font-weight: 300;
                color: #676767;
                margin-top: 0.13rem;
            }

            .footer-icon-list {
                display: flex;
                justify-content: center;
                gap: 0.35rem;
                margin-top: 0.27rem;

                .footer-icon-item {
                    width: 0.37rem;
                    height: 0.37rem;
                    border-radius: 0.2rem;
                    position: relative;
                    cursor: pointer;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    .footer-icon-img{
                        position: absolute;
                        left: 0;
                        top: 0;
                    }

                    .footer-icon-box {
                        display: none;
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        top: -1.7rem;
                        width: 1.4rem;
                        height: 1.4rem;
                    }

                    &:hover {
                        .footer-icon-box {
                            display: block;
                        }
                    }
                }
            }
        }
    }

    .footer-bottom {
        padding: 0 1.56rem;
        padding-top: 0.3rem;
        color: rgba($color: #000000, $alpha: 0.5);
        font-size: 0.15rem;

        .footer-bottom-privacy-list {
            display: flex;
            justify-content: start;
            gap: 0.24rem;
            margin-bottom: 0.13rem;

            a {
                position: relative;

                &:after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: -0.12rem;
                    width: 0.01rem;
                    height: 0.17rem;
                    background: rgba($color: #000000, $alpha: 0.5);
                }

                &:last-child {
                    &:after {
                        display: none;
                    }
                }
            }
        }
        .footer-filing {
            display: flex;
            align-items: center;
            gap: 0.2rem;
            font-size: 0.13rem;
        }
    }
}
@media screen and (max-width: 768px) { 
    .J-page-footer {
        padding-top: 1.1rem;
        .log {
            display: none;
        }
        .footer-center {
            padding: 0 0.45rem;
            flex-direction:column-reverse;
            align-items: center;
            text-align: center;
            padding-bottom: 0.72rem;
            .footer-icon {
                .footer-title {
                    font-size: 0.42rem;
                }
                .footer-desc {
                    font-size: 0.26rem;
                    margin-top: 0.36rem;
                }
                .footer-icon-list{
                    margin-top: 0.7rem;
                    gap: 1.05rem;
                    .footer-icon-item{ 
                        width: 0.86rem;
                        height: 0.86rem;
                        .footer-icon-box{
                            position: fixed;
                            left: 0;
                            top: 0;
                            width:100vw;
                            height:100vh;
                            display: flex !important;
                            justify-content: center;
                            align-items: center;
                            z-index: 999;
                            background: rgba($color: #000000, $alpha: 0.5);
                            transform: translateX(0);
                            gap: 0.5rem;
                            flex-direction: column;

                            img{
                                width: 50%;
                                height: auto;
                            }

                            .footer-icon-colse-btn{
                                width: 0.5rem;
                                height: 0.5rem;
                                margin-top: 0.5rem;
                            }
                        }
                    }
                }
            }
            .footer-btn-list {
                flex-wrap: wrap;
                gap: 1.74rem;
                row-gap: 0.53rem;
                font-size: 0.26rem;
                justify-content: center;
                margin-top: 1.35rem;
                .footer-btn{
                    position: relative;
                    &:after{ 
                        content: '';
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        right: -0.87rem;
                        width: 0.01rem;
                        height: 100%;
                        background: #c4c4c4;
                    }
                    // &:last-child{
                    //     &:after{
                    //         display: none;
                    //     }
                    // }
                }
                &.en-m-list{
                    gap:.4rem;
                    .footer-btn{ 
                        &:after{
                            right: -0.2rem;
                        }
                        &:nth-child(3){ 
                            &:after{
                                display: none;
                            }
                        }
                        &:nth-child(5){ 
                            &:after{
                                display: none;
                            }
                        }

                        &:last-child{ 

                            &:after{
                                display: none;
                            }
                        }
                    }
                }
            }
        }
        .footer-bottom { 
            padding:0;
            text-align: center;
            padding-top: 0.46rem;
            .footer-bottom-privacy-list{
                align-items: center;
                justify-content: center;
                display: flex;
                a{
                    font-size: 0.18rem;
                }
            }
            .footer-filing{
                gap: 0;
                font-size: 0.18rem;
                text-wrap: nowrap;
                justify-content: center;
                a{
                    color:#000
                }
            }
        }
    }
}
</style>
